














































































import _ from 'lodash';
import hash from 'object-hash';
import { GDPR } from '@/modules/kartoteka/gdpr';
import { editName, ERROR, TABLE_DATA, TABLE_SCHEMA, TABLE_SCHEMA_DATA, UPDATE_BASIC_TABLE_DATA, UPDATE_BASIC_TABLE_SCHEMA } from '@/main/store/listEditTypes';
import { editFactory, mapMutationsDvm } from '@/main/pages';
import { openEdit } from '@/main/router/routerPath';
import { PageMode } from '@/main/utils/pageMode';
import { snakeToPascalCase } from '@/main/utils/stringHelper';
import { Table, Row, Cell, convertToObjects } from '@/main/utils/table';
import { NAME as ZAKAZKA_CIZI_VYKONY } from '@/modules/servis/zakazka/ciziVykony/constants';
import { NAME as ZAKAZKA_KOREKCE } from '@/modules/servis/zakazka/korekce/constants';
import { NAME as ZAKAZKA_PRACOVNI_POZICE, ZAKAZKA_PP_PENDING } from '@/modules/servis/zakazka/pracovniPozice/constants';
import { NAME as JDNF } from '@/modules/servis/jednotnaFrontaNd/constants';
import { NAME as SERVISNI_PAKET } from '@/modules/servis/zakazka/servisniPakety/constants';
import { VOZIDLO_DATA_TYPE } from '@/modules/kartoteka/vozidlo/constants';
import { showNotification, showAlert } from '@/main/utils/notifications';
import { NAME as ZAKAZKA_ZALOHA } from '@/modules/servis/zalohy/constants';
import { NAME as CHECKIN } from '@/modules/servis/checkIn/constants';
import { NAME as MIO } from '@/modules/sklad/ndObjednavka/ndObjednavkaZakazka/constants';
import { editMutations as checkinEditMutations } from '@/modules/servis/checkIn/store/types';
import { EventBus } from '@/main/eventBus';


import DmsPdfDialog from '#components/DmsPdfDialog.vue';

import { PracovniPozice } from './pracovniPozice';

import {
	DEPENDENT_TABLES,
	DMS_MODULE,
	NAME,
	VYDEJKAND,
	ZAKAZKA_DRUH,
	ZAKAZKA_ND,
	zakazkaStateLocalized,
	NAME as ZAKAZKA,
	SAGA_2_HLAV,
	SAGA_2_POL,
	SAGA_2_KOM,
	TAB_NAMES,
	ZAKAZKA_PLAN_SKUT,
	REF_TABLE,
	VYDEJKA,
	ZAKAZKA_CONTROL,
	ZAKAZKA_ZAPUJCKA,
	ZAKAZKA_PNEU,
	ZAKAZKA_STAV,
	DOKLAD_OSTATNI,
	ATTACHMENT_FILES,
	NONGENUINE_ATTACHMENT_FILES,
	ADVANCEPAY,
	ZAK_ZALOHA,
	ODLOZENE_SERVISNI_CINNOSTI,
	OZAKAZKA_ON_VOZIDLO,
	OTEVRENE_ZAKAZKY,
	SERVICE_PKG_PARTS,
	SERVICE_PKG_LABOR,
	SERVICE_PACKAGE,
	POLOZKY,
	ZAKAZKA_ND_PENDING,
	RESERVE_PARTS,
	CUSTOMER_FEEDBACK,
	PENDING_JOB_LIST,
	PART_RETURN_REQUEST,
	CAMPAIGN_DETAILS,
	PART_ADD_STATUS,
	REPEAT_REPAIR_STATUS,
	PRACOVNI_POZICE,
	SERVICE_JOB_DETAILS,
	SERVICE_JOB_SPLIT_BILLING,
	SPLIT_BILLING,
	CIZI_VYKONY,
	SAVE_ORDER,
	LOAD_ORDER
} from './constants';
import { getStavZakazka } from './utils';
import { store } from './store/edit';
import { ElsaRExternalUrls } from './store/types';
import { apiProvider } from './api';
import { CiziVykony } from './ciziVykony';
import { Pneu } from './pneu';
import { Korekce } from './korekce';
import { Druhy } from './druhy';
import { Zapujcky } from './zapujcky';
import ZakazkaPendingItems from './components/ZakazkaPendingItems.vue';

export default editFactory(NAME, store).extend({
	components: {
		...Druhy,
		DmsPdfDialog,
		ZakazkaPendingItems,
	},
	created() {
		if (this.isViewMode || this.pageMode === PageMode.VIEW
			|| this.isEditMode || this.pageMode === PageMode.EDIT
			|| this.isCreateMode || this.pageMode === PageMode.CREATE) {
			const heavy: string[] = [...this.heavyTables, ...this.zakazkaTables];
			const storeUri = this.storeUri as string | undefined;
			if (!storeUri) return; 
			this._originalStoreDispatch = this.$store.dispatch;
			this.$store.dispatch = (type: string, payload?: any, options?: any) => {
				const blocked = heavy.some(
					(t) => type === `${storeUri}/${t}_${TABLE_DATA}`
						|| type === `${storeUri}/${t}_${TABLE_SCHEMA_DATA}`
						|| type === `${storeUri}/${t}_${TABLE_SCHEMA}`
				);
				const sharedSchemaOnly = [REF_TABLE, GDPR.name, ZAKAZKA_ZAPUJCKA, ZAKAZKA_PNEU, ZAKAZKA_PLAN_SKUT];
				const isSharedSchemaBlocked = sharedSchemaOnly.some(
					(t) => type === `${storeUri}/${t}_${TABLE_SCHEMA_DATA}`
						|| type === `${storeUri}/${t}_${TABLE_SCHEMA}`
				);
				if (isSharedSchemaBlocked || (blocked && !this.allowHeavyFetch)) {
					return Promise.resolve();
				}
				return (this._originalStoreDispatch as any)(type, payload, options);
			};
		}
	},
	beforeDestroy() {
		if (this._originalStoreDispatch) {
			this.$store.dispatch = this._originalStoreDispatch;
			this._originalStoreDispatch = null;
		}
	},
	data() {
		return {
			_originalStoreDispatch: null as null | ((type: string, payload?: any, options?: any) => Promise<any>),
			allowHeavyFetch: true,
			safetyRemarks: {
				visible: false,
				title: null as string | null,
				handleClose: () => {},
			},
			firstVisitDialog: {
				visible: false,
				title: null as string | null,
				notificationDialogMsg: null as string | null,
				handleClose: () => {},
			},
			splitShareValidationDialog: {
				visible: false,
				title: null as string | null,
				notificationDialogMsg: null as string | null,
				handleClose: () => {},
			},
			notificationDialog: {
				watchListDialog: false,
				partsAddStatus: null as number | null,
			},
			conflictDialog: {
				visible: false,
				title: null as string | null,
				table: null as Table | null,
				extraButtons: null as object | null,
				handleClose: () => {},
			},
			canSave: true,
			savedZakaznikId: null as number | null,
			dependencies: DEPENDENT_TABLES,
			vozidloRzvChanged: false,
			showDialogConfirmPkg: false,
			notificationMessage: '',
			isPotentialLeadVisible: false as boolean | false,
			partsLaborSchemaLoaded: false, 
			partsLaborDataLoaded: false,
			advancePaySchemaLoaded: false,
			advancePayDataLoaded: false,
			ciziKorekceSchemaLoaded: false,
			ciziKorekceDataLoaded: false,
			reservePartsSchemaLoaded: false,
			reservePartsDataLoaded: false,
			dokladSchemaLoaded: false,
			dokladDataLoaded: false,
			historySchemaLoaded: false,
			historyDataLoaded: false,
			saga2SchemaLoaded: false,
			saga2DataLoaded: false,
			saga2KomSchemaLoaded: false,
			saga2KomDataLoaded: false,
			heavyTables: [
				ZAKAZKA_ND,
				ZAKAZKA_PRACOVNI_POZICE,
				CIZI_VYKONY,
				SERVICE_JOB_DETAILS,
				ADVANCEPAY,
				ZAKAZKA_KOREKCE,
				RESERVE_PARTS,
				ATTACHMENT_FILES,
				NONGENUINE_ATTACHMENT_FILES,
				DOKLAD_OSTATNI,
				SAGA_2_HLAV,
				SAGA_2_POL,
				SAGA_2_KOM,
				ZAKAZKA_CONTROL,
			],
		};
	},
	provide(): {} {
		return {
			refreshPage: this.refreshPage,
		};
	},
	watch: {
		VozidloVin(newVal) {
			this.carDescription.enabled = false;
			if (!_.isNil(newVal)) {
				this.vehicleInformationCheck();
			}
		},
		VozidloRzv(newVal, oldVal) {
			if (newVal !== oldVal) {
				this.vozidloRzvChanged = true;
			}
		},
		canCheckVozidloConflicts(val) {
			if (val) {
				this.checkVozidloConflicts();
				this.vozidloRzvChanged = false;
			}
		},
		SplitOrderValidationPopup(val) {
			if (val) {
				this.splitShareValidationDialog.visible = true;
				this.splitShareValidationDialog.notificationDialogMsg = this.LocalizePopisostatni('SplitValidationMsg');
				this.splitShareValidationDialog.handleClose = () => {};
			}
		},
		FirstVisitVisible(val) {
			if (val && this.dmsSys.Appointment_2_JobCard_Prp) {
				this.firstVisitDialog.visible = true;
				this.firstVisitDialog.notificationDialogMsg = this.LocalizePopisostatni('CustVisit');
				this.firstVisitDialog.handleClose = () => {};
			}
		},
		ZakazkaNr(val) {
			if (val !== null && val !== 0) {
				this.titleDetail = `${val} - ${this.localizedStav}`;
			} else {
				this.titleDetail = `${this.localizedStav}`;
			}
		},
		localizedStav(val) {
			if (this.ZakazkaNr !== null && this.ZakazkaNr !== 0) {
				this.titleDetail = `${this.ZakazkaNr} - ${val}`;
			} else {
				this.titleDetail = `${val}`;
			}
		},
		entityId(val) {
			val && this.loadElsaRExternalUrls();
		},
	},
	computed: {
		canCheckVozidloConflicts(): boolean {
			return this.vozidloRzvChanged && this.zakazkaExists;
		},
		otevrenaTableExtraButtons(): Record<string, any> {
			return {
				SELECT_CONFLICT: {
					icon: 'el-icon-view',
					onClickAction: (e: any, cells: Cell[]) => this.selectedOtevrenaConflictRow(e, cells),
					value: 'SELECT_CONFLICT',
					isVisible: () => true,
				},
			};
		},
		planovanaTableExtraButtons(): Record<string, any> {
			return {
				SELECT_CONFLICT: {
					icon: 'el-icon-plus',
					onClickAction: (e: any, cells: Cell[]) => this.selectedPlanovanaConflictRow(e, cells),
					value: 'SELECT_CONFLICT',
					isVisible: () => true,
				},
			};
		},
		currentZakazka(): string | boolean {
			const actualComponent = _.findKey(ZAKAZKA_DRUH, (o) => o === this.ZakazkaDruh);
			const componentNameFormated = editName(snakeToPascalCase(actualComponent!));
			const allZakazkaComponents = _.keys(this.$options.components);
			if (_.includes(allZakazkaComponents, componentNameFormated)) return componentNameFormated;
			return false;
		},
		zakazkaExists(): boolean {
			return this.ZakazkaId! > 0;
		},
		localizedStav(): string {
			return this.LocalizePopisostatni(zakazkaStateLocalized(getStavZakazka(this.edit)));
		},
		validator(): Function {
			return (this.$refs.zakazkaBase as HTMLFormElement).$refs.zakazkaEditLayout.$children[0].$refs.mainForm.validate;
		},
		tableNd(): boolean {
			return this.zakazkaDruh !== ZAKAZKA_DRUH.ZAPUJCKA;
		},
		tableCv(): boolean {
			return this.zakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT;
		},
		tableKorekce(): boolean {
			return this.zakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT;
		},
		tableRef(): boolean {
			return (
				this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.GARANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.KULANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.MONTAZ_DV
			);
		},
		tableGDPR(): boolean {
			return (
				this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.GARANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.KULANCE
			);
		},
		tablePP(): boolean {
			return (
				this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.GARANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.KULANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.MONTAZ_DV
			);
		},
		tableZapujcka(): boolean {
			return this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA || this.zakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA || this.zakazkaDruh === ZAKAZKA_DRUH.ZAPUJCKA;
		},
		tablePneu(): boolean {
			return this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA || this.zakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA || this.zakazkaDruh === ZAKAZKA_DRUH.ZAPUJCKA;
		},
		tableSaga2(): boolean {
			return this.zakazkaDruh === ZAKAZKA_DRUH.KULANCE || this.zakazkaDruh === ZAKAZKA_DRUH.GARANCE || (this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA && this.Saga2Prp === true);
		},
		tablePlanSkut(): boolean {
			return (
				this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.GARANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.INTERNI_DILENSKA
				|| this.zakazkaDruh === ZAKAZKA_DRUH.KULANCE
				|| this.zakazkaDruh === ZAKAZKA_DRUH.MONTAZ_DV
			);
		},
		tableOsc(): boolean {
			return this.zakazkaDruh !== ZAKAZKA_DRUH.ZAPUJCKA;
		},
		tableCustFeed(): boolean {
			return this.Stav === ZAKAZKA_STAV.UZAVRENA;
		},
		zakazkaDruh(): string | null {
			return this.props.zakazkaDruh ? this.props.zakazkaDruh : this.ZakazkaDruh;
		},
		zakazkaTables(): any {
			const tables = [
				ZAKAZKA_ND_PENDING,
				ZAKAZKA_PP_PENDING,
				VYDEJKA,
				VYDEJKAND,
				DOKLAD_OSTATNI,
				ADVANCEPAY,
				ZAKAZKA_CONTROL,
				ZAK_ZALOHA,
				SERVICE_PKG_PARTS,
				SERVICE_PKG_LABOR,
				SERVICE_PACKAGE,
				POLOZKY,
				ATTACHMENT_FILES,
				NONGENUINE_ATTACHMENT_FILES,
				RESERVE_PARTS,
				PENDING_JOB_LIST,
			];
			if (this.tableKorekce) tables.push(ZAKAZKA_KOREKCE);
			if (this.tableRef) tables.push(REF_TABLE);
			if (this.tableOsc) tables.push(ODLOZENE_SERVISNI_CINNOSTI);
			if (this.tableCustFeed) tables.push(CUSTOMER_FEEDBACK);
			if (this.tableGDPR) tables.push(GDPR.name);
			if (this.tableZapujcka) tables.push(ZAKAZKA_ZAPUJCKA);
			if (this.tablePneu) tables.push(ZAKAZKA_PNEU);
			if (this.tableSaga2) tables.push(SAGA_2_HLAV, SAGA_2_POL, SAGA_2_KOM);
			if (this.tablePlanSkut) tables.push(ZAKAZKA_PLAN_SKUT);

            if (this.isViewMode || this.pageMode === PageMode.VIEW
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE) {
                return tables.filter((t) => !this.heavyTables.includes(t));
            }
			if (this.tableNd) tables.push(ZAKAZKA_ND);
			if (this.tablePP) tables.push(ZAKAZKA_PRACOVNI_POZICE);
			if (this.tableCv) tables.push(ZAKAZKA_CIZI_VYKONY);
			if (this.dependentTables.ServiceJobDetails) tables.push(SERVICE_JOB_DETAILS);
			return tables;
		},
		dependenciesById(): string[] {
			return _.filter(this.zakazkaTables, (key) => this.dependentTables[key].loadByEntityId);
		},
		dependeciesByFilter(): string[] {
			return _.filter(this.zakazkaTables, (key) => !this.dependentTables[key].loadByEntityId);
		},
		finalNotificationText(): string | undefined {
			return this.notificationDialogforWatchlistedMsg?.replace('<B>', '')?.replace('</B>', '');
		},
		zakazkaStav(): ZAKAZKA_STAV {
			return getStavZakazka(this.edit);
		},
	},
	methods: {
		...mapMutationsDvm(store.mutations),
		async customValidation() {
			let isValid = true;
			if (this.dmsSys.IsCommMode_IsDocConf_Prp) {
				if (!this.CustDocReminder && this.validationRules!.CustDocReminder.required) {
					if (ZAKAZKA_STAV.V_PRIPRAVE !== this.Stav && ZAKAZKA_STAV.NABIDKA !== this.Stav!) {
						this.showErrorAlert({ message: 'IsCustinfoAlert' });
						return false;
					}
				} else if (this.IsCustRevisit && !this.RrStatusCode && this.UvolneniDat) {
					this.showErrorAlert({ message: 'RevisitReason' });
					isValid = false;
				} else if (this.RrStatusCode === REPEAT_REPAIR_STATUS.OTHER && !this.RrDescription) {
					this.showErrorAlert({ message: 'RevisitReasonDesc' });
					isValid = false;
				}
			}
			if (this.dmsSys.PDITypePrp && this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA) {
				if (this.OrderSubtypeId === 0 || this.OrderSubtypeId === null) {
					showAlert({
						message: this.LocalizeChyboveHlasky('OrderSubTypeRequired'),
						title: 'Notification',
						options: {
							type: 'info',
						},
					});
					return false;
				}
			}
			this.canSave = isValid;
			return isValid;
		},
        async fetchTableData(this: any, tablesToFetch?: string[]): Promise<any[]> {
            let tables = tablesToFetch ?? Object.values(this.zakazkaTables);

            const combinedTables = [REF_TABLE, GDPR.name, ZAKAZKA_ZAPUJCKA, ZAKAZKA_PNEU, ZAKAZKA_PLAN_SKUT];
            const isFetchingCombinedTables = Array.isArray(tablesToFetch) &&
                tablesToFetch.length > 0 &&
                tablesToFetch.every(t => combinedTables.includes(t));

            if (isFetchingCombinedTables && this.ZakazkaId) {
                const { data: combinedData } = await apiProvider.getCombinedData(this.ZakazkaId, this.ZakaznikId, this.VyrobekvozOzn, this.PujcovnapaId);

                if (combinedData) {
                    const convertToTableRows = (rows: any[], table: Table) => {
                        if (!Array.isArray(rows) || rows.length === 0) return [];

                        return rows.map(row => {
                            if (row.cells && Array.isArray(row.cells)) {
                                return row;
                            }

                            if (row.Cells && typeof row.Cells === 'object' && !Array.isArray(row.Cells)) {
                                const cells = Object.keys(row.Cells)
                                    .sort((a, b) => parseInt(a) - parseInt(b))
                                    .map(key => row.Cells[key]);
                                return { ...row, cells, Cells: undefined };
                            }

                            const cells: any[] = [];
                            if (table && table.columns) {
                                const processColumn = (col: any) => {
                                    if (col.columns && Array.isArray(col.columns)) {
                                        col.columns.forEach(processColumn);
                                    } else if (col.propertyName) {
                                        const value = row[col.propertyName];
                                        cells[col.columnId as any] = value;
                                    }
                                };

                                table.columns.forEach(processColumn);
                            }

                            return {
                                cells,
                                operations: row.operations || row.Operations || 0
                            };
                        });
                    };

                    const commitPromises = [];

                    if (combinedData.Item1 && Array.isArray(combinedData.Item1)) {
                        const convertedRows = convertToTableRows(combinedData.Item1, this.dependentTables.RefTable);
                        commitPromises.push(
                            this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_TABLE_DATA}`, {
                                data: convertedRows,
                                tableName: REF_TABLE,
                                isEditable: this.dependentTables.RefTable?.isEditable
                            })
                        );
                    }

                    if (combinedData.Item2 && Array.isArray(combinedData.Item2)) {
                        const convertedRows = convertToTableRows(combinedData.Item2, this.dependentTables.GDPR);
                        commitPromises.push(
                            this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_TABLE_DATA}`, {
                                data: convertedRows,
                                tableName: GDPR.name,
                                isEditable: this.dependentTables.GDPR?.isEditable
                            })
                        );
                    } if (combinedData.Item3 && Array.isArray(combinedData.Item3)) {
                        const convertedRows = convertToTableRows(combinedData.Item3, this.dependentTables.ZakazkaZapujcka);
                        commitPromises.push(
                            this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_TABLE_DATA}`, {
                                data: convertedRows,
                                tableName: ZAKAZKA_ZAPUJCKA,
                                isEditable: this.dependentTables.ZakazkaZapujcka?.isEditable
                            })
                        );
                    }

                    if (combinedData.Item4 && Array.isArray(combinedData.Item4)) {
                        const convertedRows = convertToTableRows(combinedData.Item4, this.dependentTables.ZakazkaPneu);
                        commitPromises.push(
                            this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_TABLE_DATA}`, {
                                data: convertedRows,
                                tableName: ZAKAZKA_PNEU,
                                isEditable: this.dependentTables.ZakazkaPneu?.isEditable
                            })
                        );
                    } if (combinedData.Item5 && Array.isArray(combinedData.Item5)) {
                        const convertedRows = convertToTableRows(combinedData.Item5, this.dependentTables.PlanSkut);
                        commitPromises.push(
                            this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_TABLE_DATA}`, {
                                data: convertedRows,
                                tableName: ZAKAZKA_PLAN_SKUT,
                                isEditable: this.dependentTables.PlanSkut?.isEditable
                            })
                        );
                    } return Promise.all(commitPromises);
                }
                return Promise.resolve([]);
            }
			
			// Standard individual fetch for other tables
			if (!tablesToFetch) {
				tables = tables.filter(
					(value) => (this.zakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND ?
						![ZAKAZKA_PRACOVNI_POZICE, CIZI_VYKONY].includes(value) :
						![ZAKAZKA_ND, ZAKAZKA_PRACOVNI_POZICE, CIZI_VYKONY].includes(value))
				);
			}

			return Promise.all(
				tables
					.filter((value) => !( // Exclude unnecessary fetches
						(this.zakazkaDruh === ZAKAZKA_DRUH.PRODEJ_PULT || this.zakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND) && value === OZAKAZKA_ON_VOZIDLO
					))
 					.map((value) => {
						const filter = ((value === PRACOVNI_POZICE || value === CIZI_VYKONY)
										|| (value === ZAKAZKA_ND && this.zakazkaDruh === ZAKAZKA_DRUH.PREVOD_ND))
							? { filter: { ZakazkaId: this.ZakazkaId } }
								: { filter: this[`${value}Filter`] };

						return this.$store.dispatch(`${this.storeUri}/${value}_${TABLE_DATA}`, filter);
					})
			);
		},
		async fetchTableSchema(this: any, tablesToFetch: string[] = Object.values(this.zakazkaTables)): Promise<any[]> {
			return Promise.all(
				tablesToFetch.map((table) => this.$store.dispatch(`${this.storeUri}/${table}_${TABLE_SCHEMA}`))
			);
		},
		async fetchTableSchemas(): Promise<any[]> {
			const tablesToFetch = [...this.zakazkaTables]; // Ensure we're working with a new array if needed.
			if (this.zakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND) {
				tablesToFetch.push(OTEVRENE_ZAKAZKY);
				if (!this.dmsSys.EnableTaiwanPrp) {
					tablesToFetch.push(OZAKAZKA_ON_VOZIDLO);
				}
			}
			return Promise.all(tablesToFetch.map((table) => this.$store.dispatch(`${this.storeUri}/${table}_${TABLE_SCHEMA}`)));
		},
        async fetchTableSchemasCombined(this: any, tablesToFetch: string[]): Promise<any[]> {
            try {
                const { data: combinedSchemas } = await apiProvider.getCombinedSchemas(tablesToFetch);

                if (combinedSchemas && typeof combinedSchemas === 'object') {
                    const requiredFive = [REF_TABLE, GDPR.name, ZAKAZKA_ZAPUJCKA, ZAKAZKA_PNEU, ZAKAZKA_PLAN_SKUT];
                    const responseKeys = Object.keys(combinedSchemas);
                    const commitPromises = [];
                    for (const tableName of responseKeys) {
                        if (combinedSchemas[tableName]) {
                            try {
                                commitPromises.push(
                                    this.$store.commit(`${this.storeUri}/${UPDATE_BASIC_TABLE_SCHEMA}`, {
                                        data: combinedSchemas[tableName],
                                        tableName: tableName
                                    })
                                );
                            } catch (error) {
                            }
                        }
                    }
                    const missingRequired = requiredFive.filter((t) => !responseKeys.includes(t));
                    if (missingRequired.length) {
                        const prev = this.allowHeavyFetch;
                        this.allowHeavyFetch = true;
                        await Promise.all(missingRequired.map((table) => this.$store.dispatch(`${this.storeUri}/${table}_${TABLE_SCHEMA}`)));
                        this.allowHeavyFetch = prev;
                    }
                    return Promise.all(commitPromises);
                }
            } catch (error) {
                return Promise.all(tablesToFetch.map((table) => this.$store.dispatch(`${this.storeUri}/${table}_${TABLE_SCHEMA}`)));
            }
            return Promise.resolve([]);
        },
		async loadData() {
			// Block heavy table fetches during init only; restore afterwards so
			// all user-triggered operations (save, delete, etc.) work without manual toggles.
			this.allowHeavyFetch = false;
			try {
			const startTime = performance.now();
			if (this.isCreateMode) {
				const resp = await this.default();
				if (resp instanceof Error) {
					this.$router.back();
				}
				await this.fetchTableSchemas();
				await this.fetchTableData();
			} else {
				await this.entity();
					if (!this.zakazkaExists) {
						await showAlert({
							message: this.LocalizeChyboveHlasky('Invalid_Order'),
							title: this.LocalizeChyboveHlasky('DMS3_ErrorTitle'),
							options: {
								type: 'error',
								showClose: false,
							},
						});
						this.$router.back();
						return;
					}
				if (this.isViewMode || this.pageMode === PageMode.VIEW 
				|| this.isEditMode || this.pageMode === PageMode.EDIT
				|| this.isCreateMode || this.pageMode === PageMode.CREATE) {
					this.heavyTables.forEach((tableName: string) => {
						if (this.dependentTables[tableName]) {
							this.dependentTables[tableName].rows = [];
						}
					});
					await this.loadCombinedSchemas();
					await this.fetchTableData([REF_TABLE, GDPR.name,ZAKAZKA_ZAPUJCKA, ZAKAZKA_PNEU, ZAKAZKA_PLAN_SKUT]);
				} else {
					await this.fetchTableSchemas();
					await this.fetchTableData();
				}
			}
			this.loadedData();
			this.dropdownList.LaborCodes = this.dropdownList.DefaultLaborList.slice(0, 100);
			if (this.dependentTables.ZakazkaNdPending.rows.length > 0 || this.dependentTables.ZakazkaPracovniPozicePending.rows.length > 0) {
				if (this.dmsSys.WorkItemPrp) {
					this.showDialogConfirmPkg = true;
				}
			}
			this.IsApprovalDropDownVisible = !(this.AdditionalJobStatus === 1 || this.AdditionalPartStatus === 1);
			this.isPotentialLeadVisible = this.IsPotentialLead;
			const endTime  = performance.now() - startTime;
			let seconds = parseFloat((endTime / 1000).toFixed(2));
			await apiProvider.logPerformance('OrderPrp', `Order:${this.ZakazkaId}`, LOAD_ORDER, seconds);
			} finally {
				this.allowHeavyFetch = true;
			}
		},
		async loadCombinedSchemas() {
			const combinedTablesToFetch = this.zakazkaTables.filter((table: string) => !this.heavyTables.includes(table));
			await this.fetchTableSchemasCombined(combinedTablesToFetch);
		},
		async getPartsListDetails() {
			const { data: result } = await apiProvider.getPartsList('', parseInt(this.entityId!, 10));
			this.dropdownList.DefaultPartsList = result.DropDownList.partsList;
			this.DefaultWarehouseId = result.DefaultWarehouseId;
		},
		async checkDnpValue() {
			const response = await apiProvider.CheckDnpValue(parseInt(this.entityId!, 10));
			this.IsDNPVisible = response?.data;
		},
		async loadElsaRExternalUrls() {
			if (this.entityId) {
				const { data: btnsUrls } = await apiProvider.workshopInfoViews(parseInt(this.entityId, 10));
				btnsUrls && (this.elsaRExternalUrls = btnsUrls as ElsaRExternalUrls[]);
			}
			await this.getPartsListDetails();
			await this.checkDnpValue();
		},
		async checkVozidloConflicts() {
			const { VozidloVin, VozidloRzv, ZakaznikId } = this.edit;
			if ((this.isCreateMode || this.isEditMode) && VozidloRzv) {
				if (this.isCreateMode) {
					await this.$store.dispatch(`${this.storeUri}/${OTEVRENE_ZAKAZKY}_${TABLE_DATA}`, {
						filter: { OtevrenePrp: true, PripravaPrp: true, UzavrenePrp: false, Spz: VozidloRzv, KaroserieNr: VozidloVin },
					});
				}
				if (this.zakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT && this.zakazkaDruh !== ZAKAZKA_DRUH.PREVOD_ND && !this.dmsSys.EnableTaiwanPrp) {
					await this.$store.dispatch(`${this.storeUri}/${OZAKAZKA_ON_VOZIDLO}_${TABLE_DATA}`, { filter: { Spz: VozidloRzv, ZakaznikId } });
				}
				if (this.dependentTables[OTEVRENE_ZAKAZKY].rows.length) {
					await this.showConfirmOtevrena();
				} else if (this.dependentTables[OZAKAZKA_ON_VOZIDLO].rows.length) {
					await this.showConfirmPlanovana();
				}
			}
		},
		async selectedOtevrenaConflictRow(row: Row, cells: Cell[]) {
			const RECORD_ID_INDEX = 0;
			openEdit(ZAKAZKA, PageMode.VIEW, { props: true, id: cells[RECORD_ID_INDEX] });
			this.conflictDialog.visible = false;
		},
		async selectedPlanovanaConflictRow(row: Row, cells: Cell[]) {
			this.startLoading();
			const RECORD_ID_INDEX = 0;
			await apiProvider.mergeWithOzakazka({ zakazkaId: this.ZakazkaId!, ozakazkaId: cells[RECORD_ID_INDEX] });
			this.conflictDialog.visible = false;
			this.endLoading();
		},
		async showConfirmMessage(message: string) {
			return this.showConfirm({
				message: this.LocalizeChyboveHlasky(message),
				title: this.LocalizeChyboveHlasky('questionTitle'),
				options: {
					confirmButtonText: this.Localize('Ano'),
					cancelButtonText: this.Localize('Ne'),
				},
			});
		},
		async showConfirmOtevrena() {
			const showConfirmPlanovanaIfExists = () => {
				if (this.dependentTables[OZAKAZKA_ON_VOZIDLO].rows.length) {
					this.showConfirmPlanovana();
				}
			};

			if (await this.showConfirmMessage('OtevZakazkaNaVozidloEx')) {
				this.conflictDialog.title = this.LocalizePopisostatni('ZakazkStatus2');
				this.conflictDialog.table = this.dependentTables[OTEVRENE_ZAKAZKY];
				this.conflictDialog.extraButtons = this.otevrenaTableExtraButtons;
				this.conflictDialog.handleClose = showConfirmPlanovanaIfExists;
				this.conflictDialog.visible = true;
			} else {
				showConfirmPlanovanaIfExists();
			}
		},
		async showConfirmPlanovana() {
			if (await this.showConfirmMessage('PlanZakExist')) {
				this.conflictDialog.title = this.LocalizePopisostatni('PZPlanned');
				this.conflictDialog.table = this.dependentTables[OZAKAZKA_ON_VOZIDLO];
				this.conflictDialog.extraButtons = this.planovanaTableExtraButtons;
				this.conflictDialog.handleClose = () => {};
				this.conflictDialog.visible = true;
			}
		},
		async clickAdd(create: (id: string | number) => void) {
			if (!this.zakazkaExists) {
				const result = await this.changeToEdit();
				if (result instanceof Error) {
					return;
				}
			}

			if (this.isEditMode && this.isModified) {
				const saveResult = await this.save(false);
				if (saveResult instanceof Error) {
					return;
				}
			}

			create(this.ZakazkaId!);
		},
		async createPP(ZakazkaId: number) {
			if (this.loggedUser.DmsSys.WatchlistedApprovalPrp && this.edit.IsWatchlisted) {
				this.notificationMessage = this.LocalizeChyboveHlasky('NotificationForAddJobCard');
				this.notificationDialog.watchListDialog = true;
				this.notificationDialog.partsAddStatus = PART_ADD_STATUS.JOB;
			} else {
				if (this.dmsSys.WorkItemPrp && this.IsAllItemLevelStatusEntered) {
					const areAllItemsCompleted = !await this.showConfirmMessage('IsAllItemCompleted');
					if (areAllItemsCompleted) return;
				}
				this.savePP(ZakazkaId);
			}
		},
		savePP(ZakazkaId: number) {
			openEdit(PracovniPozice.name, PageMode.CREATE, {
				props: true,
				filter: {
					ZakazkaId,
					...(this.edit.PracovnikId && { PracovnikId: this.edit.PracovnikId }),
					KaroserieNr: this.edit.VozidloVin,
				},
			});
		},
		async createND(ZakazkaId: number) {
			if (this.loggedUser.DmsSys.WatchlistedApprovalPrp && this.edit.IsWatchlisted) {
				this.notificationMessage = this.LocalizeChyboveHlasky('NotificationForAddPart');
				this.notificationDialog.watchListDialog = true;
				this.notificationDialog.partsAddStatus = PART_ADD_STATUS.PART;
			} else {
				if (this.dmsSys.WorkItemPrp && this.IsAllItemLevelStatusEntered) {
					const areAllItemsCompleted = !await this.showConfirmMessage('IsAllItemCompleted');
					if (areAllItemsCompleted) return;
				}
				this.openCreateParts(ZakazkaId);
			}
		},
		openCreateParts(ZakazkaId: number) {
			openEdit(ZAKAZKA_ND, PageMode.CREATE, {
				props: true,
				filter: {
					ZakazkaId,
					WarehouseId: this.edit.WarehouseId,
					ZakazkaDruh: this.edit.ZakazkaDruh,
					...(this.edit.PracovnikId && { PracovnikId: this.edit.PracovnikId }),
				},
			});
		},
		createCiziVykony(ZakazkaId: number) {
			openEdit(CiziVykony.name, PageMode.CREATE, { props: true, filter: { ZakazkaId, ...(this.edit.PracovnikId && { PracovnikId: this.edit.PracovnikId }) } });
		},
		createSlevyKorekce(ZakazkaId: number) {
			openEdit(Korekce.name, PageMode.CREATE, { props: true, filter: { ZakazkaId, ...(this.edit.PracovnikId && { PracovnikId: this.edit.PracovnikId }) } });
		},
		createPneu(ZakazkaId: number) {
			openEdit(Pneu.name, PageMode.CREATE, { filter: { ZakazkaId }, ZakaznikId: this.ZakaznikId, VozidloId: this.VozidloId });
		},
		createZapujcka() {
			openEdit(Zapujcky.name, PageMode.CREATE, { props: true, filter: { ZakazkaId: this.ZakazkaId }, ZakaznikId: this.ZakaznikId });
		},
		createOsc() {
			if (this.VozidloId) {
				openEdit(VOZIDLO_DATA_TYPE.ZAVADA, PageMode.CREATE, { filter: { VozidloId: this.VozidloId } });
			} else {
				showNotification({ title: this.Localize('Chyba'), message: this.LocalizeChyboveHlasky('MissVoz') });
			}
		},
		createZaloha() {
			const filter = {
				ZakazkaId: this.ZakazkaId!,
				ZakazkaNr: this.ZakazkaNr,
				ZakaznikIdText: this.ZakaznikIdText,
				VozidloText: this.VozidloText,
			};
			openEdit(ZAKAZKA_ZALOHA, PageMode.CREATE, { props: true, filter });
		},
		async refreshFun() {
			if (localStorage.Revisit) {
				this.IsCustRevisit = true;
				localStorage.removeItem('Revisit');
			}

			this.allowHeavyFetch = true;

			const fetchTableDataIfNeeded = async (routeName: any, tableName: any) => {
				if (this.prevRouteName === routeName) {
					await this.fetchTableData([tableName]);
				}
			};

		    if (this.prevRouteName && (this.dependencies as readonly string[]).includes(this.prevRouteName)) {
				await this.fetchTableData([this.prevRouteName]);
			}

			await fetchTableDataIfNeeded(VOZIDLO_DATA_TYPE.ZAVADA, ODLOZENE_SERVISNI_CINNOSTI);
			await fetchTableDataIfNeeded(PART_RETURN_REQUEST, ZAKAZKA_ND);
			await fetchTableDataIfNeeded(SERVICE_JOB_SPLIT_BILLING, SERVICE_JOB_DETAILS);

			if (this.prevRouteName === JDNF) {
				const schemaTables: string[] = [];
				const dataTables: string[] = [];
				schemaTables.push(ZAKAZKA_ND); dataTables.push(ZAKAZKA_ND); 
				schemaTables.push(ZAKAZKA_PRACOVNI_POZICE); dataTables.push(ZAKAZKA_PRACOVNI_POZICE); 
				schemaTables.push(CIZI_VYKONY); dataTables.push(CIZI_VYKONY); 
				schemaTables.push(SERVICE_JOB_DETAILS); dataTables.push(SERVICE_JOB_DETAILS); 

				if (!this.partsLaborSchemaLoaded && schemaTables.length) {
					await this.fetchTableSchema(schemaTables);
					this.partsLaborSchemaLoaded = true;
				}
				if (!this.partsLaborDataLoaded && dataTables.length) {
					await this.fetchTableData(dataTables);
					this.partsLaborDataLoaded = true;
				}
			}

			const garanceRoutes = [ZAKAZKA_ND, ZAKAZKA_CIZI_VYKONY, ZAKAZKA_PRACOVNI_POZICE];
			if (this.ZakazkaDruh === ZAKAZKA_DRUH.GARANCE && garanceRoutes.includes(this.prevRouteName!)) {
				await this.fetchTableData([SAGA_2_POL]);
			}

			if ([ZAKAZKA_ND, SERVISNI_PAKET, ZAKAZKA_PRACOVNI_POZICE].includes(this.prevRouteName!)) {
				await this.getPaketyCount();
			}

			if (this.prevRouteName === SPLIT_BILLING) {
				await this.entity();
			}

			if ([ZAKAZKA_ND, ZAKAZKA_PRACOVNI_POZICE, JDNF, MIO].includes(this.prevRouteName!)) {
				const { data: status } = await apiProvider.getWorkCompletionStatus({ zakazkaId: this.ZakazkaId });
				this.IsAllItemLevelStatusEntered = status;

				if (this.IsAllItemLevelStatusEntered && (this.dmsSys.SendMailNotificationPrp || this.dmsSys.SendSmsNotificationPrp)) {
					await apiProvider.sendWorkNotification({ zakaznikId: this.ZakaznikId, zakazkaNr: this.ZakazkaNr });
				}

				this.CenaCelkem = (await apiProvider.getPrice(this.ZakazkaId)).data;
				this.IsSplittedOrder = (await apiProvider.isSplittedOrder(this.ZakazkaId)).data;
			}
		},
		/** When leaving, saves the target route to be used in {@link refreshFun} on return. */
		async doBeforeUload(event: any) {
			this.prevRouteName = event.to.meta.objectName;
			if (this.isEditMode && this.Stav === ZAKAZKA_STAV.OTEVRENA && this.shouldRemoveFromPageManager(event.to)) {
				await new Promise(async (resolutionFunc) => {
					this.tiskDialog.dialogClosed = () => {
						resolutionFunc(true);
					};
					const doVydej = await this.printVydejkaNd();
					!doVydej && resolutionFunc(true);
				});
			}
		},
		/* override (main/pages/edit.ts) */
		async saveClick() {
			const startTime = performance.now();
			if (this.VozidloId! > 0 && [ZAKAZKA_DRUH.DILENSKA, ZAKAZKA_DRUH.GARANCE, ZAKAZKA_DRUH.KULANCE].includes(this.edit.ZakazkaDruh!)) {
				if (this.dependentTables.NonGenuineAttachmentFiles && this.dependentTables.NonGenuineAttachmentFiles.rows.length < 1) {
					if (this.edit.IsTotalLoss && (!this.edit.TotalLossRemark || this.edit.TotalLossRemark === '')) {
						this.showErrorAlert({ message: 'DMS_ATTACHEMENTTOTALLOSS' });
						return;
					}
					if (this.edit.IsNonGenuine && (!this.edit.NonGenuineRemark || this.edit.NonGenuineRemark === '')) {
						this.showErrorAlert({ message: 'DMS_NONGENUINE' });
						return;
					}
				}
			}
			if (this.canSave && this.edit.ZakazkaDruh !== ZAKAZKA_DRUH.PRODEJ_PULT && this.dmsSys.SendMailNotificationPrp) {
				await this.sendAdditionalAmountNotification();
			}

			if (this.loggedUser.DmsSys.WatchlistedApprovalPrp && this.WatchlistFlag && !this.StatusResult) {
				this.notificationMessage = this.LocalizeChyboveHlasky('Job_Card_Notification');
				this.notificationDialog.watchListDialog = true;
				this.notificationDialog.partsAddStatus = PART_ADD_STATUS.ORDER;
				this.edit.IsWatchlistedVehicle = true;
			} else {
				await this.saveZakazka();
				let iTotalTimeTaken = performance.now() - startTime;
				let seconds = parseFloat((iTotalTimeTaken / 1000).toFixed(2));
				await apiProvider.logPerformance('OrderPrp', `Order:${this.ZakazkaId}`, SAVE_ORDER, seconds);
			}
		},
		async saveZakazka() {
			this.startLoading();
			try {
				if (this.ZakazkaDruh === ZAKAZKA_DRUH.DILENSKA && !this.ContactTypeId) {
					this.showErrorAlert({ message: this.LocalizeChyboveHlasky('RequiredFieldsNotFilled') });
					return;
				}
				if (this.isCreateMode) {
					const { data: isDuplicateOrderData } = await apiProvider.isDuplicateOrder(this.VozidloId);
					if (isDuplicateOrderData) {
						this.showErrorAlert({
							message: `${this.LocalizePopisPoli('DUPLICATE_ORDER_VALIDATION')} ${this.VozidloVin}`,
						});
						return;
					}
				}

				const { data: isLineItemPresent } = await apiProvider.isLineItemPresent(this.ZakazkaId, this.VozidloId, this.ZakaznikId);
				if (isLineItemPresent) {
					this.showErrorAlert({
						message: this.LocalizeChyboveHlasky('lineItemPresent'),
					});
					return;
				}

				this.RrStatusCode = this.RrStatusCode ?? REPEAT_REPAIR_STATUS.NOT_APPLICABLE;
				this.IsCustomerFirstVisit = this.FirstVisitVisible;

				if (!this.zakazkaExists) {
					this.notificationDialog.watchListDialog = false;
					await this.changeToEdit();
					if (this.parentUri && this.parentUri.includes(CHECKIN)) {
						this.$store.commit(
							`${this.parentUri}/${checkinEditMutations.CREATED_ZAKAZKA}`,
							{
								ZakazkaId: this.ZakazkaId,
								ZakazkaNr: this.ZakazkaNr,
							},
						);
					}
					
				} else {
					const partsData = this.preparePartsData();
					const laborTable = this.prepareLaborTable();
					const extLaborTable = this.prepareExtLaborTable();
					const serviceJobsData = this.prepareServiceJobsData();

					if (this.hasInvalidLabor(laborTable)) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_LABOUR') });
						return;
					}

					if (this.hasInvalidExtLabor(extLaborTable)) {
						this.showErrorAlert({ message: this.LocalizeChyboveHlasky('PLEASE_ENTER_REQUIRED_VALUES_FOR_EXTERNAL_LABOUR') });
						return;
					}

					await this.manageOperations(partsData, laborTable, extLaborTable, serviceJobsData);

					await this.save(false);
					if (this.zakazkaDruh === ZAKAZKA_DRUH.DILENSKA && this.ContactTypeId) {
						//Call api to save contact details
						await apiProvider.saveCustomerContactDetails(
							{
								orderType: 'NORMAL',
								orderId: this.ZakazkaId!,
								vehicleId: this.VozidloId!,
								contactTypeId: this.ContactTypeId!,
								userId: this.loggedUser.PracovnikData.PracovnikId
							});
					}
					await this.afterLaborSaveProcess();

					const { data: isLaborInProgress } = await apiProvider.isLaborInProgress(this.ZakazkaId);
					if (isLaborInProgress) {
						const proceedWithSave = await this.showConfirm({
							message: this.LocalizeChyboveHlasky('LABOR_IN_PROGRESS_VALIDATION'),
							title: this.LocalizeChyboveHlasky('questionTitle'),
							options: {
								confirmButtonText: this.Localize('Ano'),
								cancelButtonText: this.Localize('Ne'),
							},
						});
						if (proceedWithSave) {
							const response = await apiProvider.assignLaborOperations(this.ZakazkaId);
							if (response?.data) {
								let displayMessage: string;
								if (response.data === 'WMS_CHIP_VAL') {
									displayMessage = this.LocalizeChyboveHlasky('WMS_CHIP_VAL');
								} else if (response.data === 'WMS_CHIP_OVERLAP_VAL') {
									displayMessage = this.LocalizeChyboveHlasky('WMS_CHIP_OVERLAP_VAL');
								} else {
									displayMessage = response.data + ' ' + this.LocalizeChyboveHlasky('IGNORED_LABOR_ASSIGNMENT');
								}

								showAlert({
									message: displayMessage,
									title: 'Notification',
									options: {
										type: 'info',
									},
								});
							}
						} else {
							await apiProvider.autoAssignCancelled(this.ZakazkaId);
						}
					}
				}

				EventBus.$emit(SAVE_ORDER, { zakazkaId: this.ZakazkaId });
			} finally {
				this.endLoading();
			}
		},
		preparePartsData() {
			return convertToObjects(this.dependentTables.ZakazkaNd).map((part) => ({
				...part,
				RecordId: part.RecordId < 0 ? null : part.RecordId,
				ZakazkaId: this.ZakazkaId,
			}));
		},
		prepareLaborTable() {
			return convertToObjects(this.dependentTables.ZakazkaPracovniPozice).map((labor) => ({
				...labor,
				LaborId: labor.LaborId < 0 ? 0 : labor.LaborId,
				IsAdditional: labor.IsAdditional ?? false,
				ZakazkaId: this.ZakazkaId,
			}));
		},
		prepareExtLaborTable() {
			return convertToObjects(this.dependentTables.ZakazkaCiziVykony).map((labor) => ({
				...labor,
				LaborId: labor.LaborId < 0 ? 0 : labor.LaborId,
				ZakazkaId: this.ZakazkaId,
			}));
		},
		prepareServiceJobsData() {
			return convertToObjects(this.dependentTables.ServiceJobDetails).map((serviceJob) => ({
				...serviceJob,
				Id: serviceJob.Id < 0 ? 0 : serviceJob.Id,
				ServiceOrderId: this.ZakazkaId,
				ZakazkaId: this.ZakazkaId,
			}));
		},
		hasInvalidLabor(laborTable: any[]) {
			return laborTable.some((item) => !item.Text || !item.LabourNumber || item.CostCenter === null);
		},
		hasInvalidExtLabor(extLaborTable: any[]) {
			return extLaborTable.some((item) => !item.LabourNumber || !item.Cost || !item.UnitOfMeasurement || !item.Quantity || !item.SupplierName || !item.LaborPrice);
		},
		async manageOperations(partsData: any[], laborTable: any[], extLaborTable: any[], serviceJobsData: any[]) {
			const partsGridHash = hash(this.dependentTables.ZakazkaNd?.rows);
			const laborGridHash = hash(this.dependentTables.ZakazkaPracovniPozice?.rows);
			const extLaborGridHash = hash(this.dependentTables.ZakazkaCiziVykony?.rows);
			const serviceJobsGridHash = hash(this.dependentTables.ServiceJobDetails?.rows);

			const proceedForPartsGridAPI = this.isProceedForAPI(partsData, this.dependentTables.ZakazkaNd, partsGridHash);
			const proceedForLaborsGridAPI = this.isProceedForAPI(laborTable, this.dependentTables.ZakazkaPracovniPozice, laborGridHash);
			const proceedForExtLaborsGridAPI = this.isProceedForAPI(extLaborTable, this.dependentTables.ZakazkaCiziVykony, extLaborGridHash);
			const proceedForServiceJobGridAPI = this.isProceedForAPI(serviceJobsData, this.dependentTables.ServiceJobDetails, serviceJobsGridHash);

			if (proceedForPartsGridAPI) {
				const partOperations = {
					ZakazkaId: this.ZakazkaId,
						PartsOperations: partsData
				};
				await apiProvider.managePartsOperations(partOperations);
				await this.fetchTableData([ZAKAZKA_ND]);
			}
			if (proceedForLaborsGridAPI) {
				const laborOperations = {
					ZakazkaId: this.ZakazkaId,
						LaborOperations: laborTable
				};
				await apiProvider.manageLaborOperations(laborOperations);
				await this.fetchTableData([PRACOVNI_POZICE]);
			}
			if (proceedForExtLaborsGridAPI) {
				const extLaborOperations = {
					ZakazkaId: this.ZakazkaId,
						ExtLaborOperations: extLaborTable
				};
				await apiProvider.manageExtLaborOperations(extLaborOperations);
				await this.fetchTableSchema([CIZI_VYKONY]);
				await this.fetchTableData([CIZI_VYKONY]);
			}
			if (proceedForServiceJobGridAPI) {
				const serviceJobOperations = {
					ZakazkaId: this.ZakazkaId,
					ServiceJobDetails: serviceJobsData
				};
				await apiProvider.manageServiceJobOperations(serviceJobOperations);
				await this.fetchTableData([SERVICE_JOB_DETAILS]);
				this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => serviceJobsData.map(data => data.ServiceJobId).includes(x.Value));
				//this.ServiceJobs = serviceJobsData.map(function (item) { return item.Id; });
					const tablesToUpdate = this.canUpdateTableData();
				if (tablesToUpdate.length > 0) {
					await this.fetchTableData(tablesToUpdate);
					this.edit.UpdatedServiceJobIds = [];
				}
				// ElsaPro sync call
				if (this.IsElsaProAutosync) {
					apiProvider.AssignWorkshopOrders(this.ZakazkaId!);
				}
			}
			
		},
		  canUpdateTableData() {
				const TableFeatchArray = [];
                const partserviceJobIdColId = this.dependentTables.ZakazkaNd.cellNames!.SERVICE_JOB_ID;
				const zakazkaNdServiceJobIds = this.dependentTables.ZakazkaNd.rows.map(row => row.cells[partserviceJobIdColId]);
				const hasPartUpdate = this.edit.UpdatedServiceJobIds.some(id => zakazkaNdServiceJobIds.includes(id));
				if(hasPartUpdate) {
					TableFeatchArray.push(ZAKAZKA_ND);
				}
				const laborserviceJobIdColId = this.dependentTables.ZakazkaPracovniPozice.cellNames!.SERVICE_JOB_NAME;
				const zakazkaPracovniPoziceJobIds = this.dependentTables.ZakazkaPracovniPozice.rows.map(row => row.cells[laborserviceJobIdColId]);
				const hasLaborUpdate = this.edit.UpdatedServiceJobIds.some(id => zakazkaPracovniPoziceJobIds.includes(id.toString()));
				if(hasLaborUpdate) {
					TableFeatchArray.push(PRACOVNI_POZICE);
				}
				const exOperationServiceJobIdColId = this.dependentTables.ZakazkaCiziVykony.cellNames!.SERVICE_JOB_NAME;
				const zakazkaCiziVykonyJobIds = this.dependentTables.ZakazkaCiziVykony.rows.map(row => row.cells[exOperationServiceJobIdColId]);
				const hasExOperationUpdate = this.edit.UpdatedServiceJobIds.some(id => zakazkaCiziVykonyJobIds.includes(id.toString()));
				if(hasExOperationUpdate) {
					TableFeatchArray.push(CIZI_VYKONY);
				}
            return TableFeatchArray;
        },
		isProceedForAPI(gridData: any[], gridRows: Table, gridRowsHash: any): boolean {
			return gridData?.length > 0 && gridRows?.hash !== gridRowsHash;
		},
		async afterLaborSaveProcess() {
			const { data: status } = await apiProvider.getWorkCompletionStatus({ zakazkaId: this.ZakazkaId! });
			this.IsAllItemLevelStatusEntered = status;
			if (this.IsAllItemLevelStatusEntered && (this.dmsSys.SendMailNotificationPrp || this.dmsSys.SendSmsNotificationPrp)) {
				await apiProvider.sendWorkNotification({ zakaznikId: this.ZakaznikId!, zakazkaNr: this.ZakazkaNr });
			}
			const [priceData, isSplittedOrderData] = await Promise.all([
				apiProvider.getPrice(this.ZakazkaId!),
				apiProvider.isSplittedOrder(this.ZakazkaId!)
			]);
			this.CenaCelkem = priceData.data;
			this.IsSplittedOrder = isSplittedOrderData.data;
		},
		async sendAdditionalAmountNotification() {
			if (this.edit.TotalCostLimit! > 0) {
				this.edit.IsAdditionalAmountDisabled = true;
			}
			if (this.ZakazkaId! && this.edit.ZakaznikId! && (this.edit.CenaCelkem! > 0) && (this.edit.CenaCelkem! > this.edit.OldTotalPrice!)) {
				const inputDto = {
					OrderId: this.ZakazkaId,
					OldTotalPrice: this.edit.OldTotalPrice,
					NewTotalPrice: this.edit.CenaCelkem,
				};
				this.edit.OldTotalPrice = this.edit.CenaCelkem;
				this.startLoading();
				await apiProvider.sendNotificationForAdditionalAmount(inputDto);
				this.endLoading();
			}
		},
		loadedData() {
			this.displayFirstVisitDetails();
			if (this.IsSafetyRemarks) {
				this.safetyRemarks.visible = true;
				this.safetyRemarks.title = this.LocalizeChyboveHlasky('PreSaftyRemarks');
			}
			if (this.IsPotentialLead) {
				this.isPotentialLeadVisible = true;
			}
			this.savedZakaznikId = this.edit.ZakaznikId!;
			if (this.isCreateMode) {
				this.recomputeHash();
			}
			if (this.dependentTables.ServiceJobDetails.rows.length > 0) {
				const serviceJobsData = this.prepareServiceJobsData();
				this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => serviceJobsData.map(data => data.ServiceJobId).includes(x.Value));
				//this.ServiceJobs = serviceJobsData.map(function (item) { return item.Id; });
			}
		},
		displayFirstVisitDetails() {
			if (!this.isCreateMode && this.IsCustomerFirstVisit && this.dmsSys.CustomerFirstPrp) {
				this.FirstVisitVisible = true;
			}
		},
		async additionalTabClick(tab: any) {
			const tabName = tab.$props.name;
			switch (tabName) {
				case TAB_NAMES.KALKULACE: {
					await this.handleKalkulaceTabClick();
					break;
				}
				case TAB_NAMES.ADVANCEPAY: {
					if (!(this.isViewMode || this.pageMode === PageMode.VIEW 
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [ADVANCEPAY];
						const dataTables: string[] = [ADVANCEPAY];
						if (!this.advancePaySchemaLoaded) {
							await this.fetchTableSchema(schemaTables);
							this.advancePaySchemaLoaded = true;
						}
						if (!this.advancePayDataLoaded) {
							await this.fetchTableData(dataTables);
							this.advancePayDataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.CIZI_VYKONY_SLEVY_KOREKCE: {
						if (!(this.isViewMode || this.pageMode === PageMode.VIEW 
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [];
						const dataTables: string[] = [];
						if (this.tableCv) { schemaTables.push(CIZI_VYKONY); dataTables.push(CIZI_VYKONY); }
						if (this.tableKorekce) { schemaTables.push(ZAKAZKA_KOREKCE); dataTables.push(ZAKAZKA_KOREKCE); }
						if (!this.ciziKorekceSchemaLoaded && schemaTables.length) {
							await this.fetchTableSchema(schemaTables);
							this.ciziKorekceSchemaLoaded = true;
						}
						if (!this.ciziKorekceDataLoaded && dataTables.length) {
							await this.fetchTableData(dataTables);
							this.ciziKorekceDataLoaded = true;
						}

						if (this.dependentTables.ServiceJobDetails.rows.length > 0) {
							const serviceJobsData = this.prepareServiceJobsData();
							this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => serviceJobsData.map(data => data.ServiceJobId).includes(x.Value));
						}
						else {
							await this.fetchTableSchema([SERVICE_JOB_DETAILS]);
							await this.fetchTableData([SERVICE_JOB_DETAILS]);

							const serviceJobsData = this.prepareServiceJobsData();
							this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => serviceJobsData.map(data => data.ServiceJobId).includes(x.Value));
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.PARTS_RESERVE: {
						if (!(this.isViewMode || this.pageMode === PageMode.VIEW 
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [RESERVE_PARTS];
						const dataTables: string[] = [RESERVE_PARTS];
						if (!this.reservePartsSchemaLoaded) {
							await this.fetchTableSchema(schemaTables);
							this.reservePartsSchemaLoaded = true;
						}
						if (!this.reservePartsDataLoaded) {
							await this.fetchTableData(dataTables);
							this.reservePartsDataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.ND:{
					const isView = this.isViewMode || this.pageMode === PageMode.VIEW
					 || this.isEditMode || this.pageMode === PageMode.EDIT
					 || this.isCreateMode || this.pageMode === PageMode.CREATE;
					const druh = this.edit.ZakazkaDruh;

					const isBlockedDruh = druh === ZAKAZKA_DRUH.PREVOD_ND || druh === ZAKAZKA_DRUH.PRODEJ_ZBOZI;

					if (!isView && !isBlockedDruh) {
						break;
					}
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [];
						const dataTables: string[] = [];
						if (this.tableNd) { schemaTables.push(ZAKAZKA_ND); dataTables.push(ZAKAZKA_ND); }
						if (!this.partsLaborSchemaLoaded && schemaTables.length) {
							await this.fetchTableSchema(schemaTables);
							this.partsLaborSchemaLoaded = true;
						}
						if (!this.partsLaborDataLoaded && dataTables.length) {
							await this.fetchTableData(dataTables);
							this.partsLaborDataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.PRAC: {
					if (!(this.isViewMode || this.pageMode === PageMode.VIEW 
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) {
						break;
					}
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [];
						const dataTables: string[] = [];
						if (this.tableNd) { schemaTables.push(ZAKAZKA_ND); dataTables.push(ZAKAZKA_ND); }
						if (this.tablePP) { schemaTables.push(ZAKAZKA_PRACOVNI_POZICE); dataTables.push(ZAKAZKA_PRACOVNI_POZICE); }
						if (this.tableCv) { schemaTables.push(CIZI_VYKONY); dataTables.push(CIZI_VYKONY); }
						if (this.dependentTables.ServiceJobDetails) { schemaTables.push(SERVICE_JOB_DETAILS); dataTables.push(SERVICE_JOB_DETAILS); }

						if (!this.partsLaborSchemaLoaded && schemaTables.length) {
							await this.fetchTableSchema(schemaTables);
							this.partsLaborSchemaLoaded = true;
						}
						if (!this.partsLaborDataLoaded && dataTables.length) {
							await this.fetchTableData(dataTables);
							this.partsLaborDataLoaded = true;
						}

						if (this.dependentTables.ServiceJobDetails.rows.length > 0) {
							const serviceJobsData = this.prepareServiceJobsData();
							this.dropdownList.ServiceJobForItems = this.dropdownList.ServiceJobs.filter((x:any) => serviceJobsData.map(data => data.ServiceJobId).includes(x.Value));
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.DOKLAD: {
					if (!(this.isViewMode || this.pageMode === PageMode.VIEW
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [ATTACHMENT_FILES, NONGENUINE_ATTACHMENT_FILES, DOKLAD_OSTATNI];
						const dataTables: string[] = [ATTACHMENT_FILES, NONGENUINE_ATTACHMENT_FILES, DOKLAD_OSTATNI];
						if (!this.dokladSchemaLoaded) {
							await this.fetchTableSchema(schemaTables);
							this.dokladSchemaLoaded = true;
						}
						if (!this.dokladDataLoaded) {
							await this.fetchTableData(dataTables);
							this.dokladDataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.SAGA_2: { 
					if (!(this.isViewMode || this.pageMode === PageMode.VIEW
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [];
						const dataTables: string[] = [];
						if (this.tableSaga2) { 
							schemaTables.push(SAGA_2_HLAV, SAGA_2_POL);
							dataTables.push(SAGA_2_HLAV, SAGA_2_POL);
						}
						if (!this.saga2SchemaLoaded && schemaTables.length) {
							await this.fetchTableSchema(schemaTables);
							this.saga2SchemaLoaded = true;
						}
						if (!this.saga2DataLoaded && dataTables.length) {
							await this.fetchTableData(dataTables);
							this.saga2DataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.SAGA_2_KOMUNIKACE: {
					if (!(this.isViewMode || this.pageMode === PageMode.VIEW
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [];
						const dataTables: string[] = [];
						if (this.tableSaga2) {
							schemaTables.push(SAGA_2_KOM);
							dataTables.push(SAGA_2_KOM);
						}
						if (!this.saga2KomSchemaLoaded && schemaTables.length) {
							await this.fetchTableSchema(schemaTables);
							this.saga2KomSchemaLoaded = true;
						}
						if (!this.saga2KomDataLoaded && dataTables.length) {
							await this.fetchTableData(dataTables);
							this.saga2KomDataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				case TAB_NAMES.HISTORY: { 
					if (!(this.isViewMode || this.pageMode === PageMode.VIEW 
					|| this.isEditMode || this.pageMode === PageMode.EDIT
					|| this.isCreateMode || this.pageMode === PageMode.CREATE)) break;
					this.allowHeavyFetch = true;
					this.startLoading();
					try {
						const schemaTables: string[] = [ZAKAZKA_CONTROL];
						const dataTables: string[] = [ZAKAZKA_CONTROL];
						if (!this.historySchemaLoaded) {
							await this.fetchTableSchema(schemaTables);
							this.historySchemaLoaded = true;
						}
						if (!this.historyDataLoaded) {
							await this.fetchTableData(dataTables);
							this.historyDataLoaded = true;
						}
					} catch (err) {
						this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
					} finally {
						this.endLoading();
					}
					break;
				}
				default:
					break;
			}
		},
		async handleKalkulaceTabClick() {
			this.startLoading();
			try {
				if (this.Stav === ZAKAZKA_STAV.OTEVRENA) {
					const isSaved = await this.save(false);
					if (isSaved.status !== 200) {
						throw new Error(isSaved.statusText);
					}
				}
				if (!this.isCreateMode) {
					const promises = this.dropdownList.KalkulacePzn.map((kalkulacePzn: any) =>
						apiProvider.isKalkulaceSentToRemote({ zakazkaId: this.ZakazkaId!, kalkulacePzn: kalkulacePzn.Value })
					);
					const awaitedCalculations = await Promise.all(promises);
					const remoteCalculation = awaitedCalculations.find((c: any) => c.data);
					if (remoteCalculation) {
						const { data: remoteCalculationHtml } = await apiProvider.getKalkulaceRtfAsHtml({ zakazkaId: this.ZakazkaId! });
						this.KalkPreviewRtf = remoteCalculationHtml;
						this.KalkulacePzn = remoteCalculation.config.params.kalkulacePzn;
					}
				}
			} catch (err) {
				this.$store.dispatch(ERROR, { moduleKey: DMS_MODULE, stateKey: editName(NAME), err }, { root: true });
			} finally {
				this.endLoading();
			}
		},
		async saveDetailsAndSendWatchlistedEmail() {
			this.notificationDialog.watchListDialog = false;
			await apiProvider.sendWatchlistedEmail(this.edit);
			switch (this.notificationDialog.partsAddStatus) {
				case PART_ADD_STATUS.ORDER:
					await this.saveZakazka();
					break;
				case PART_ADD_STATUS.PART:
					await this.openCreateParts(this.ZakazkaId);
					break;
				case PART_ADD_STATUS.JOB:
					await this.savePP(this.ZakazkaId);
					break;
				default:
					break;
			}
		},
	},
});
